var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 10.7421L12 11.0957L12.3536 10.7421L17.9364 5.15927C18.1861 4.90955 18.591 4.90955 18.8407 5.15927C19.0905 5.40899 19.0905 5.81387 18.8407 6.06359L13.2579 11.6464L12.9043 12L13.2579 12.3536L18.8407 17.9364C19.0905 18.1861 19.0905 18.591 18.8407 18.8407C18.591 19.0905 18.1861 19.0905 17.9364 18.8407L12.3536 13.2579L12 12.9043L11.6464 13.2579L6.06359 18.8407C5.81387 19.0905 5.40899 19.0905 5.15927 18.8407C4.90955 18.591 4.90955 18.1861 5.15927 17.9364L10.7421 12.3536L11.0957 12L10.7421 11.6464L5.15927 6.06359C4.90955 5.81387 4.90955 5.40899 5.15927 5.15927C5.40899 4.90955 5.81387 4.90955 6.06359 5.15927L11.6464 10.7421Z",
    fill: "#292929",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuClose);
export default __webpack_public_path__ + "static/media/IconMenuClose.9a209878aa48d6fa94cf145c939da85d.svg";
export { ForwardRef as ReactComponent };